import { render, staticRenderFns } from "./OtherSection.vue?vue&type=template&id=04eec392&"
import script from "./OtherSection.vue?vue&type=script&lang=js&"
export * from "./OtherSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports